import Rellax from 'rellax';

const selectors = {
  parallaxWrapper: '[data-parallax-wrapper]',
  parallaxImg: '[data-parallax-img]',
};

let sections = {};

const parallaxImage = {
  onLoad() {
    sections[this.id] = [];
    const frames = this.container.querySelectorAll(selectors.parallaxWrapper);
    frames.forEach((frame) => {
      const inner = frame.querySelector(selectors.parallaxImg);
      sections[this.id].push(
        new Rellax(inner, {
          center: true,
          round: true,
          frame: frame,
        })
      );
    });
  },
  onUnload: function () {
    sections[this.id].forEach((image) => {
      if (typeof image.destroy === 'function') {
        image.destroy();
      }
    });
  },
};

export default parallaxImage;
